// extracted by mini-css-extract-plugin
module.exports = {"playBtn":"LazyVideo_playBtn__1vImS"};